import { render } from "./spesaItem.vue?vue&type=template&id=858415f8&ts=true"
import script from "./spesaItem.vue?vue&type=script&lang=ts"
export * from "./spesaItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__